/**
 * 将标题转换为URL友好的格式
 * 将空格替换为连字符，并进行适当的编码
 * @param title - 要转换的标题
 * @returns URL友好的字符串
 */
export const formatTitleForUrl = (title: string): string => {
  if (!title) {return "";}
  
  return title
    .trim()
    .replace(/\s+/g, "-") // 将一个或多个空格替换为单个连字符
    .replace(/[^\w\-\u4e00-\u9fa5]/g, "") // 移除除了字母、数字、连字符和中文字符之外的特殊字符
    .replace(/-+/g, "-") // 将多个连续的连字符替换为单个连字符
    .replace(/^-+|-+$/g, "").toLowerCase(); // 移除开头和结尾的连字符
};

/**
 * 从URL友好的格式还原标题（如果需要的话）
 * @param urlTitle - URL中的标题部分
 * @returns 还原后的标题
 */
export const formatUrlToTitle = (urlTitle: string): string => {
  if (!urlTitle) {return "";}
  
  return decodeURIComponent(urlTitle)
    .replace(/-/g, " ") // 将连字符替换回空格
    .trim();
};
